import { render, staticRenderFns } from "./FilterSummaryOptionTapirMk.vue?vue&type=template&id=0d97c984&"
import script from "./FilterSummaryOptionTapirMk.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionTapirMk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports